import ltGuestSignIn from 'html/checkout/lt-guest-sign-in.html';
import App from 'app/app.js';
import 'app/directive/LtGuestSignInCtrl.js';

function LtGuestSignInDirective() {
  return {
    restrict: 'E',
    scope: {
      guestTitle: '@',
      description: '@',
      data: '=',
      onWriteCache: '&',
      routeBackToPath: '=',
      signInPosition: '@',
      guestFormValidation: '=',
      validateInput: '&',
      validateEmail: '&',
      showFields: '='
    },
    template: ltGuestSignIn,
    controller: 'LtGuestSignInCtrl',
    controllerAs: 'guestSignIn'
  };
}

App.directive('ltGuestSignIn', [LtGuestSignInDirective]);
